import { render, staticRenderFns } from "./RsaAccettazioneSchedeValutazioneComponent.vue?vue&type=template&id=0da6cd8e"
import script from "./RsaAccettazioneSchedeValutazioneComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneSchedeValutazioneComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports